import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import {
  TextBoxMaxLine1FontSmBold,
  TextBoxMaxLine1FontXs,
} from 'atoms/TextBox/Templates'
import { COLOR } from 'vars/color'
import {
  ProfileTypeMenuButtonSC,
  ProfileTypeMenuButtonTextSC,
} from './ProfileTypeMenuButton.styled'

interface IProfileTypeMenuButtonProps {
  title: string
  description?: string
  onClick?: () => void
  selected?: boolean
}

export const ProfileTypeMenuButton = ({
  title,
  description,
  selected = true,
  onClick,
}: IProfileTypeMenuButtonProps) => {
  return (
    <ProfileTypeMenuButtonSC onClick={onClick}>
      <ProfileTypeMenuButtonTextSC>
        <TextBoxMaxLine1FontSmBold title={title} />

        {description && <TextBoxMaxLine1FontXs title={description} />}
      </ProfileTypeMenuButtonTextSC>

      {selected && (
        <Icon
          name={IconNames.check}
          size={IconSizes.mSm}
          color={COLOR.ACCENT_SECONDARY}
        />
      )}
    </ProfileTypeMenuButtonSC>
  )
}
